import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const PauseIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g>
                <g>
                    <path fill="currentColor" d="M12,22.25C6.348,22.25,1.75,17.652,1.75,12S6.348,1.75,12,1.75S22.25,6.348,22.25,12S17.652,22.25,12,22.25z M12,3.25c-4.825,0-8.75,3.925-8.75,8.75s3.925,8.75,8.75,8.75s8.75-3.925,8.75-8.75S16.825,3.25,12,3.25z"/>
                </g>
            </g>
            <path fill="currentColor" d="M10,16L10,16c-0.552,0-1-0.448-1-1V9c0-0.552,0.448-1,1-1h0c0.552,0,1,0.448,1,1v6C11,15.552,10.552,16,10,16z"/>
            <path fill="currentColor" d="M14,16L14,16c-0.552,0-1-0.448-1-1V9c0-0.552,0.448-1,1-1h0c0.552,0,1,0.448,1,1v6C15,15.552,14.552,16,14,16z"/>
        </SvgIcon>
    );
};